
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Experience the thrill of Goa’s top casinos, with exciting games, great entertainment, and delicious food. Perfect for a night of fun and excitement.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the best casinos in Goa, where you can enjoy thrilling games, live entertainment, and great dining options. Ideal for a memorable night out.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy a night at Goa’s top casinos, offering exciting games, tasty food, and live entertainment. Perfect for a fun and exciting evening!',
},


        {
          hid: 'keywords',
          name: 'keywords',
          content: 'casino in goa, best casino in goa, best casino in goa with price, cheapest casino in goa, top casino in goa, land casino in goa, cruise casino in goa',
        },

      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Thrilling Games",
      text: "Experience the excitement of Goa's top casinos with a variety of thrilling games!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether you're a beginner or a pro, there's something for everyone at our casinos!",
    },
    {
      title: "Expert Staff",
      text: "Our friendly and professional staff ensure you have a smooth and enjoyable experience.",
    },
    {
      title: "Easy Booking",
      text: "Book your casino experience quickly and easily through the Goa App at great rates!",
    },
  ],

      title: 'Casino in Goa - Best Casino in Goa with Price',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/casino-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/casino-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/casino-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Casino in Goa - Book @ ₹1999 Flat 50% Off",
  "description": "Enjoy the best casino experience in Goa with top-notch gaming options, live entertainment, and luxurious amenities for an unforgettable night.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1999",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/casino-goa",
        "url": "https://www.goa.app/casino-goa",
        "name": "Casino in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-20T12%3A05%3A25.531Z9.jpg?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=RJ%2BbK90UCpGmLX9BVkYDeN7Db8nm9Z2JEHmBnApZBW7jcI%2FIzGmljnuaIXTARfjGyx1MtY6Co9T4D2QyUX6bNnjLcvvGuuz61eZbgLN62VfWS0r8mb4b4q%2F7VrA6uk77h1MhWJZvC6vi23MDLH%2B%2Fvl%2FsF7E9nwNZgfnRz1S4Q8X5k5nP3yCu%2BW8lIC5JpByfdfuUR%2F0APx1xbnPnzW82cE8TYeKl0d9XGdCvjqu3IU%2Foy1sEKwv%2F4jVp5m5%2FEKpT9Guy9NpIvwBOXHjii3H9N1MtOMhondBlYRlG8eXC7dqWZCJi9SZKJdukvc32ZU4ldQVaWaUlErM2%2F8VcbAUWvA%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Best Casinos in Goa offer an unforgettable experience with exciting games, live entertainment, and luxurious amenities. Perfect for gaming enthusiasts or special events, these casinos let you enjoy Goa’s vibrant nightlife and thrilling atmosphere while trying your luck at popular games like Blackjack, Poker, and Roulette.",
        "breadcrumb": {
            "@id": "https://www.goa.app/casino-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/casino-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
    "@type": "Question",
    "name": "How do I book a casino in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can book a casino in Goa by visiting their official websites or through popular booking platforms. It's advisable to book in advance, especially during peak tourist seasons."
    }
  },
  {
    "@type": "Question",
    "name": "What is included in a casino package in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Casino packages in Goa typically include entry fees, a welcome drink, and access to gaming tables. Some packages may also offer meals and entertainment options."
    }
  },
  {
    "@type": "Question",
    "name": "What is the dress code for casinos in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The dress code for most casinos in Goa is smart casual. It's recommended to wear comfortable yet classy attire. Avoid flip-flops and beachwear."
    }
  },
  {
    "@type": "Question",
    "name": "What are the operating hours of casinos in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most casinos in Goa operate 24/7, allowing guests to enjoy gaming and entertainment at any time. However, it's good to check specific casino timings."
    }
  },
  {
    "@type": "Question",
    "name": "Can I customize my experience at a casino in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, many casinos offer customizable packages for special events like birthdays or corporate gatherings, including private gaming areas and dining options."
    }
  },
  {
    "@type": "Question",
    "name": "Are meals and drinks included in the casino experience?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Some casinos include complimentary meals and drinks, while others may charge separately. It's best to verify the specifics while booking."
    }
  },
  {
    "@type": "Question",
    "name": "What is the price range for entry to casinos in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Entry fees for casinos in Goa typically start from ₹500 and can vary based on the casino and the package you choose."
    }
  },
  {
    "@type": "Question",
    "name": "Can I book a casino for a special occasion?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Absolutely! Many casinos in Goa are equipped to host special events and celebrations, offering tailored packages to suit your needs."
    }
  },
  {
    "@type": "Question",
    "name": "What is the best time to visit a casino in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The best time to visit casinos in Goa is during the winter months from November to February, when the weather is pleasant and tourism is at its peak."
    }
  },
  {
    "@type": "Question",
    "name": "Can I bring my own food and drinks into the casino?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most casinos do not allow outside food and beverages. They usually have in-house restaurants and bars to cater to guests. Check the specific policy of the casino you are visiting."
    }
  },
  {
    "@type": "Question",
    "name": "Are there options for live entertainment in casinos?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, many casinos in Goa offer live entertainment options such as music performances, dance shows, and themed nights to enhance the gaming experience."
    }
  }
        ]
      }
    ]
  };
},


};


  